declare const process: { env: { [key: string]: string | undefined } };
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';
export const NTN = process.env.REACT_APP_NTN || '14465147';
